import { HTMLAttributes } from 'react'
import { Portal } from '@integration-app/react'
import clsx from 'clsx'

import classes from './styles.module.css'
import { useSchemaBuilderRowContext } from '../row-context'

export function PropertiesPortal() {
  const { setPropertiesRef } = useSchemaBuilderRowContext()
  return <div className={clsx(classes.propertyList)} ref={setPropertiesRef} />
}

export function Properties({ children }) {
  const { propertiesRef } = useSchemaBuilderRowContext()
  return <Portal node={propertiesRef}>{children}</Portal>
}

function PropertyRoot({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={classes.propertyWrapper}>
      <span className={clsx(classes.property, className)} {...props}>
        {children}
      </span>
    </span>
  )
}

function PropertyName({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={clsx(classes.propertyName, className)} {...props}>
      {children}
    </span>
  )
}

function PropertyValue({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={clsx(classes.propertyValue, className)} {...props}>
      {children}
    </span>
  )
}

export const Property = Object.assign(PropertyRoot, {
  Name: PropertyName,
  Value: PropertyValue,
})

export function PropertiesInModal({ children }) {
  return <div className={classes.propertiesInModal}>{children}</div>
}
